import React from "react";

const HowItWorks = () => {
  return (
    <div
      className="section-full site-bg-light twm-how-it-work-wrap wow fadeInDown"
      data-wow-offset="100"
      data-wow-delay="0.2"
    >
      <div className="section-content">
        <div className="twm-how-it-work-section container-fluid">
          <div className="row">

            {/* ================================
                LEFT IMAGE
            ================================= */}

            <div className="col-lg-6 col-md-12">
              <div className="twm-how-it-work-media">
                <img
                  src="/images/howw.png"
                  alt="Garud Cab Service Booking Process"
                  className="img-fluid"
                />
              </div>
            </div>

            {/* ================================
                RIGHT CONTENT
            ================================= */}

            <div className="col-lg-6 col-md-12">
              <div className="twm-how-it-work-content">

                {/* Section Heading */}
                <div className="section-head left">

                  <div className="twm-sm-title left">
                    Simple Booking Process
                  </div>

                  <h2 className="twm-large-title site-text-dark">
                    Your Ride With Garud Cab Service
                  </h2>

                  <div className="section-head-detail">
                    Booking a cab with Garud Cab Service is quick and
                    convenient. Follow a few simple steps and get ready for a
                    comfortable journey.
                  </div>

                </div>

                <div className="row">

                  {/* ================================
                      STEP 1
                  ================================= */}

                  <div className="col-lg-6 col-md-6 col-sm-6 m-b30">
                    <div className="twm-w-steps-st2">

                      <div className="twm-w-step-count">
                        <span>01</span>
                      </div>

                      <div className="twm-w-step-detail">
                        <h3 className="twm-title">
                          Select Your Ride
                        </h3>

                        <p>
                          Tell us your pickup location, destination, travel
                          date, and preferred cab type according to your
                          journey requirements.
                        </p>
                      </div>

                    </div>
                  </div>

                  {/* ================================
                      STEP 2
                  ================================= */}

                  <div className="col-lg-6 col-md-6 col-sm-6 m-b30">
                    <div className="twm-w-steps-st2">

                      <div className="twm-w-step-count">
                        <span>02</span>
                      </div>

                      <div className="twm-w-step-detail">
                        <h3 className="twm-title">
                          Share Your Details
                        </h3>

                        <p>
                          Provide your basic contact and travel information so
                          our team can arrange the right cab for your trip.
                        </p>
                      </div>

                    </div>
                  </div>

                  {/* ================================
                      STEP 3
                  ================================= */}

                  <div className="col-lg-6 col-md-6 col-sm-6 m-b30">
                    <div className="twm-w-steps-st2">

                      <div className="twm-w-step-count">
                        <span>03</span>
                      </div>

                      <div className="twm-w-step-detail">
                        <h3 className="twm-title">
                          Confirm Your Booking
                        </h3>

                        <p>
                          Review your journey details, confirm the booking,
                          and receive the necessary trip information from our
                          team.
                        </p>
                      </div>

                    </div>
                  </div>

                  {/* ================================
                      STEP 4
                  ================================= */}

                  <div className="col-lg-6 col-md-6 col-sm-6 m-b30">
                    <div className="twm-w-steps-st2">

                      <div className="twm-w-step-count">
                        <span>04</span>
                      </div>

                      <div className="twm-w-step-detail">
                        <h3 className="twm-title">
                          Enjoy Your Ride
                        </h3>

                        <p>
                          Meet your driver at the pickup point and enjoy a
                          smooth, comfortable, and convenient journey with
                          Garud Cab Service.
                        </p>
                      </div>

                    </div>
                  </div>

                </div>
              </div>
            </div>

            {/* End Right Content */}

          </div>
        </div>
      </div>
    </div>
  );
};

export default HowItWorks;
